import{jsxs as o,jsx as t}from"react/jsx-runtime";import{styled as p}from"styled-components";import{BOTTOM_AREA as r,FOOTER as e}from"../constants/ElementId.mjs";const i=p.div`
  padding: 8px 16px 8px 0px;
  min-height: 32px;
  max-height: 200px;
  overflow: auto;
  border-top: 1px solid #a3a3a3;
  box-shadow: 0px -1px 4px #ccc;
  background: url('images/bbg.png') repeat-x scroll right top #d8e1db;
`,d=p.div`
  padding: 3px;
`;function n({footer:p,buttons:n}){return o(i,{id:r,children:[p&&t(d,{id:e,children:p}),n]})}export{n as BottomArea};
